import React from 'react';

const sectors = ['Private Equity', "Fonds d'investissement", 'Société de gestion', 'FPCI', 'SLP', 'Capital innovation', 'LBO', 'Build up'];

export const SectorsMarquee = () => (
  <section className="marquee py-6 bg-primary-blue" aria-label="Secteurs accompagnés">
    <div className="marquee-track">
      {[...sectors, ...sectors].map((sector, i) => (
        <span key={`${sector}-${i}`} className="inline-flex items-center">
          <span className="font-heading text-2xl md:text-4xl font-light uppercase tracking-wider text-white/70 px-8">
            {sector}
          </span>
          <span className="w-2 h-2 rounded-full bg-warm-accent flex-shrink-0" />
        </span>
      ))}
    </div>
  </section>
);
